<template>
    <div>
        <Toolbar>
            <!-- RIGHT -->
            <template v-slot:right>
                <HelpButton />
            </template>
        </Toolbar>
        <div class="card card-custom">
            <div class="card-header">
                <div class="card-title">
                    <h3 class="card-label">
                        {{ __("product.article.update") }}
                    </h3>
                </div>
            </div>

            <div
                v-if="!success && !canUpdate"
                class="alert alert-custom alert-light-primary"
                role="alert"
            >
                <div class="alert-icon">
                    <i class="fa fa-exclamation-triangle" />
                </div>
                <div class="alert-text">
                    <div class="text-lg font-weight-bold">
                        {{ __("product.article.data_quality") }}
                    </div>
                </div>
            </div>

            <div class="timeline timeline-5 card-body">
                <div class="timeline-items">
                    <CheckEan
                        class="ml-13 mb-6"
                        :preset-ean="queryEan"
                        :update-article="true"
                        @useFoundArticle="setArticle"
                    ></CheckEan>
                    <div v-if="articleFound">
                        <div class="timeline-item">
                            <div class="timeline-media bg-light-primary">
                                <i class="fa fa-tags"></i>
                            </div>
                            <div
                                class="timeline-desc timeline-desc-light-primary"
                            >
                                <span
                                    class="d-block font-weight-bolder text-primary mb-2"
                                >
                                    {{ __("navigation.product_data") }}
                                </span>

                                <div
                                    class="alert alert-custom alert-light-primary"
                                    role="alert"
                                >
                                    <div class="alert-icon">
                                        <i class="fa fa-exclamation-triangle" />
                                    </div>
                                    <div
                                        class="alert-text"
                                        v-html="
                                            __('product.article.update_note')
                                        "
                                    />
                                </div>

                                <div class="form-group mb-8 row">
                                    <div class="col-lg-6 mb-8 mb-lg-0">
                                        <label>
                                            {{ __("general.product_name") }}
                                        </label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            :placeholder="
                                                __('general.product_name')
                                            "
                                            v-model="productName"
                                        />
                                        <div
                                            v-if="
                                                productName !==
                                                article.product.name
                                            "
                                            class="form-text text-success"
                                        >
                                            {{
                                                __(
                                                    "product.article.original_price"
                                                )
                                            }}: {{ article.product.name }}
                                        </div>
                                        <small
                                            v-if="errors[`product_name`]"
                                            class="form-text text-danger"
                                        >
                                            {{ errors[`product_name`][0][0] }}
                                        </small>
                                        <small
                                            v-else
                                            class="form-text text-muted"
                                        >
                                            {{
                                                __(
                                                    "product.article.new_product_name"
                                                )
                                            }}
                                        </small>
                                    </div>

                                    <div class="col-lg-6">
                                        <label>
                                            {{
                                                __(
                                                    "general.product_description"
                                                )
                                            }}
                                        </label>
                                        <textarea
                                            type="text"
                                            class="form-control"
                                            v-model="productDescription"
                                            :placeholder="
                                                __(
                                                    'general.product_description'
                                                )
                                            "
                                        ></textarea>
                                        <div
                                            v-if="
                                                productDescription !==
                                                article.product.description
                                            "
                                            class="form-text text-success"
                                        >
                                            {{
                                                __(
                                                    "product.article.description_updated"
                                                )
                                            }}
                                        </div>
                                        <small
                                            v-if="errors[`product_description`]"
                                            class="form-text text-danger"
                                        >
                                            {{
                                                errors[
                                                    `product_description`
                                                    ][0][0]
                                            }}
                                        </small>
                                        <small
                                            v-else
                                            class="form-text text-muted"
                                        >
                                            {{
                                                __(
                                                    "product.article.general_description"
                                                )
                                            }}
                                        </small>
                                    </div>
                                </div>

                                <div class="form-group mb-8 row">
                                    <div class="col-lg-6">
                                        <label>
                                            {{
                                                __(
                                                    "product.brand_section.search_and_select_brand"
                                                )
                                            }}
                                        </label>
                                        <new-article-brand
                                            v-if="!brand.name"
                                            :user-brands-only="false"
                                            :old-value="
                                                this.article.product.brand
                                            "
                                            @selectBrand="selectBrand"
                                        >
                                        </new-article-brand>
                                        <div v-else>
                                            <input
                                                class="form-control"
                                                type="text"
                                                v-model="brand.name"
                                                disabled
                                            />
                                            <small
                                                @click="resetBrand"
                                                class="form-text text-muted cursor-pointer"
                                            >
                                                {{
                                                    __(
                                                        "product.brand_section.change_selection"
                                                    )
                                                }}
                                            </small>
                                        </div>
                                        <small
                                            v-if="errors[`brand_uuid`]"
                                            class="form-text text-danger"
                                        >
                                            {{ errors[`brand_uuid`][0][0] }}
                                        </small>
                                    </div>
                                    <div v-if="!brand.name" class="col-lg-6">
                                        <label>
                                            {{
                                                __(
                                                    "product.brand_section.create_own_brand"
                                                )
                                            }}
                                        </label>
                                        <div>
                                            <button
                                                @click="
                                                    createBrand = !createBrand
                                                "
                                                type="button"
                                                class="btn btn-primary"
                                            >
                                                <i
                                                    class="fas fa-plus-square"
                                                ></i>
                                                {{
                                                    __(
                                                        "product.brand_section.create_new_brand"
                                                    )
                                                }}
                                            </button>
                                            <div
                                                class="mt-4"
                                                v-if="createBrand"
                                            >
                                                <create-user-brand
                                                    @selectBrand="selectBrand"
                                                ></create-user-brand>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <category-selection
                                    @setCategory="setCategory"
                                    :old-value="
                                        article.product.category
                                            ? article.product.category.id
                                            : null
                                    "
                                ></category-selection>
                            </div>
                        </div>

                        <div class="timeline-item">
                            <div class="timeline-media bg-light-primary">
                                <i class="fa fa-clipboard"></i>
                            </div>
                            <div
                                class="timeline-desc timeline-desc-light-primary"
                            >
                                <span
                                    class="d-block font-weight-bolder text-primary mb-2"
                                >
                                    {{ __("general.article_data") }}
                                </span>

                                <div class="form-group mb-8 row">
                                    <div class="col-lg-6 mb-8 mb-lg-0">
                                        <label>
                                            {{ __("general.article_name") }}
                                        </label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            :placeholder="
                                                __('general.article_name')
                                            "
                                            v-model="articleName"
                                        />
                                        <div
                                            v-if="articleName !== article.name"
                                            class="form-text text-success"
                                        >
                                            {{
                                                __(
                                                    "product.article.original_price"
                                                )
                                            }}: {{ article.name }}
                                        </div>
                                        <small
                                            v-if="errors[`article_name`]"
                                            class="form-text text-danger"
                                        >
                                            {{ errors[`article_name`][0][0] }}
                                        </small>
                                        <small
                                            v-else
                                            class="form-text text-muted"
                                        >
                                            {{
                                                __(
                                                    "product.article.new_article_name"
                                                )
                                            }}
                                        </small>
                                    </div>

                                    <div class="col-lg-6">
                                        <label>
                                            {{ __("general.producer_number") }}
                                        </label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            :placeholder="
                                                __('general.producer_number')
                                            "
                                            v-model="sku"
                                        />
                                        <div
                                            v-if="
                                                sku !==
                                                article.manufacturer_article_number
                                            "
                                            class="form-text text-success"
                                        >
                                            {{
                                                __(
                                                    "product.article.original_price"
                                                )
                                            }}:
                                            {{
                                                article.manufacturer_article_number
                                            }}
                                        </div>
                                        <small class="form-text text-muted">
                                            {{
                                                __(
                                                    "product.article_variants.producer_number_description"
                                                )
                                            }}
                                        </small>
                                    </div>
                                </div>

                                <div
                                    v-if="attributes.length > 0"
                                    class="form-group row mb-8"
                                >
                                    <div
                                        v-for="(attribute, index) in attributes"
                                        class="col-lg-6 mb-2"
                                    >
                                        <label>{{ attribute.name }}</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="145643345251"
                                            v-model="attribute.pivot.value"
                                        />
                                        <div
                                            v-if="
                                                attribute.pivot.value !==
                                                article.attributes[index].pivot
                                                    .value
                                            "
                                            class="form-text text-success"
                                        >
                                            {{
                                                __(
                                                    "product.article.original_price"
                                                )
                                            }}:
                                            {{
                                                article.attributes[index].pivot
                                                    .value
                                            }}
                                        </div>
                                        <small
                                            v-if="errors[`attributes.*.value`]"
                                            class="form-text text-danger"
                                        >
                                            {{
                                                errors[
                                                    `attributes.*.value`
                                                    ][0][0]
                                            }}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="timeline-item">
                            <div class="timeline-media bg-light-primary">
                                <i class="fas fa-file-image"></i>
                            </div>
                            <div
                                class="timeline-desc timeline-desc-light-primary"
                            >
                                <span
                                    class="d-block font-weight-bolder text-primary mb-2"
                                >
                                    {{ __("general.article_images") }}
                                </span>
                                <div
                                    class="form-group mb-8 row justify-content-center"
                                >
                                    <div
                                        v-for="(image, index) in images"
                                        class="border border-light col-md-4 col-lg-3 col-6 d-flex"
                                    >
                                        <div
                                            @click="
                                                removeImage(image.id, index)
                                            "
                                            class="position-absolute cursor-pointer bg-secondary p-3 right-0"
                                        >
                                            <i
                                                class="fas fa-trash text-danger fa-2x"
                                            ></i>
                                        </div>
                                        <img
                                            :src="image.url"
                                            class="max-h-300px mx-auto rounded overflow-hidden"
                                            style="object-fit: contain"
                                            :alt="__('general.article_images')"
                                        />
                                    </div>
                                </div>
                                <div class="row justify-content-around">
                                    <label
                                        for="uploadImages"
                                        class="btn btn-primary mb-6 mb-md-0"
                                    >
                                        <span class="svg-icon svg-icon-md">
                                            <i class="fas fa-file-image"></i>
                                        </span>
                                        {{ __("product.article.add_images") }}
                                    </label>

                                    <div
                                        class="btn btn-primary"
                                        @click="resetImages()"
                                    >
                                        <span class="svg-icon svg-icon-md">
                                            <i class="fas fa-trash"></i>
                                        </span>
                                        {{ __("product.article.revert_value") }}
                                    </div>
                                </div>
                                <input
                                    ref="uploadImages"
                                    id="uploadImages"
                                    type="file"
                                    @change="imagesChanged($event)"
                                    multiple
                                    class="d-none"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!success" class="ml-14 my-10">
                <button
                    v-if="articleFound && !loading"
                    @click="submit"
                    class="btn btn-primary"
                >
                    {{ __("product.article.update") }}
                    <i class="ml-3 fa fa-arrow-right" aria-hidden="true"></i>
                </button>
                <div v-if="loading" class="d-flex align-items-center mr-4">
                    <div class="ml-2 text-muted"></div>
                    <div class="spinner spinner-primary mr-10"></div>
                </div>
            </div>

            <div v-else class="ml-14 my-10">
                <a :href="$route('article.update.show')">
                    <button class="btn btn-primary mx-2 flex-1" type="button">
                        <i class="fas fa-plus-square"></i
                        >{{ __("product.article.next_update") }}
                    </button>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import CheckEan from "@components/Article/CheckEan.vue";
import ArticleBox from "@components/Article/ArticleBox.vue";
import CategorySelection from "@components/Category/CategorySelection.vue";
import NewArticleBrand from "@components/Article/NewArticleBrand.vue";
import CreateUserBrand from "@components/Brand/CreateUserBrand.vue";
import Toolbar from '@components/Toolbar.vue'
import BackButton from '@components/BackButton.vue'
import HelpButton from '@components/HelpButton.vue'

export default {
    components: {
        HelpButton,
        BackButton, Toolbar,
        CreateUserBrand,
        NewArticleBrand,
        CategorySelection,
        ArticleBox,
        CheckEan,
    },

    props: {
        queryEan: String,
        userSourceQuality: Number,
    },

    data() {
        return {
            articleFound: false,
            createBrand: false,
            article: {
                ean: "",
                manufacturer_article_number: "",
                images: [],
                attributes: [],
                source_quality: 0,
                product: {
                    category: {
                        id: null,
                    },
                    brand: {
                        uuid: "",
                        name: "",
                    },
                },
            },
            productName: "",
            productDescription: "",
            articleName: "",
            brand: {
                uuid: "",
                name: "",
            },
            sku: "",
            attributes: [],
            images: [],
            deleteImages: [],
            newImages: [],
            category: {},
            errors: {},
            loading: false,
            success: false,
        };
    },

    methods: {
        async submit() {
            this.errors = {};
            this.loading = true;

            let formData = new FormData();
            this.attributes.forEach(function (attribute, index) {
                formData.append(`attributes[${index}][id]`, attribute.id);
                formData.append(
                    `attributes[${index}][value]`,
                    attribute.pivot.value
                );
            });
            this.deleteImages.forEach(function (imageId, index) {
                formData.append(`delete_images_ids[${index}]`, imageId);
            });
            this.newImages.forEach(function (image, index) {
                formData.append(`new_images[${index}]`, image);
            });
            formData.append("ean", this.article.ean);
            formData.append("brand_uuid", this.brand.uuid);
            formData.append("product_name", this.productName);
            formData.append("product_description", this.productDescription);
            formData.append("article_name", this.articleName);
            formData.append("sku", this.sku ? this.sku : "");
            formData.append(
                "category_id",
                this.category ? this.category.id : null
            );

            try {
                let response = await axios.post(
                    route("article.update.handle"),
                    formData
                );

                toastr.success(response.data);
                this.loading = false;
                this.success = true;
            } catch (error) {
                this.errors = error.response.data.errors;
                if (error.response.status === 422) {
                    toastr.error(__("product.toast_submit.error"));
                } else {
                    toastr.error(error.message);
                }
                this.loading = false;
            }
        },

        setArticle(article) {
            this.article = article;
            this.productName = article.product.name;
            this.productDescription = article.product.description;
            this.articleName = article.name;
            this.sku = article.manufacturer_article_number;
            this.attributes = _.cloneDeep(article.attributes);
            this.images = _.cloneDeep(article.images);
            this.category = _.cloneDeep(article.product.category);
            this.articleFound = true;
        },

        removeImage(imageId, index) {
            this.$delete(this.images, index);
            this.deleteImages.push(imageId);
        },

        resetImages() {
            this.images = _.cloneDeep(this.article.images);
            this.deleteImages = [];
        },

        imagesChanged(event) {
            for (let key in event.target.files) {
                if (!event.target.files.hasOwnProperty(key)) continue;
                this.images.unshift({
                    url: URL.createObjectURL(event.target.files[key]),
                });
                this.newImages.push(event.target.files[key]);
            }
        },

        setCategory(category) {
            this.category = category;
        },

        selectBrand(brand) {
            this.brand = brand;
            this.createBrand = false;
        },

        resetBrand() {
            this.brand.name = "";
            this.brand.uuid = "";
        },
    },

    computed: {
        canUpdate() {
            return this.article.source_quality <= this.userSourceQuality;
        },
    },
};
</script>
